// extracted by mini-css-extract-plugin
module.exports = {"paginationDiv":"paginationDiv--3qy3-v8J"};